export * from './layer';

/**
 * load layers action creator
 *
 * @param {array} layers -  array of layer object
 * @returns {{payload: *, type: string}}
 */
export const loadLayers = layers => {
    return {
        type   : 'LAYERS_LOADED',
        payload: layers
    };
};

/**
 * activate layer action creator
 *
 * @param {array} layer - array of layer object
 * @returns {{payload: *, type: string}}
 */
export const activateLayer = layers => {
    return {
        type   : 'LAYER_ACTIVATED',
        payload: layers
    };
};

/**
 * hide layer action creator
 *
 * @param layers
 * @returns {{payload: *, type: string}}
 */
export const hideLayer = layers => {
    return {
        type   : 'LAYER_HIDE',
        payload: layers
    };
};

/**
 * activate sub layer/legends action creator
 *
 * @param {array} layer - array of layer object
 * @returns {{payload: *, type: string}}
 */
export const activateSubLayer = layer => {
    return {
        type   : 'SUBLAYER_ACTIVATED',
        payload: layer
    };
};

/**
 * sort layer action creator
 *
 * @param {array} layer - array of layer object
 * @returns {{payload: *, type: string}}
 */
export const sortLayers = layers => {
    return {
        type   : 'LAYER_SORTED',
        payload: layers
    };
};

/**
 * reset all layer layer action creator
 *
 * @returns {{payload: [], type: string}}
 */
export const resetLayers = layers => {
    return {
        type   : 'RESET_LAYERS',
        payload: layers
    };
};

/**
 * layer date filtering action creator
 *
 * @param layer
 * @param from
 * @param to
 * @returns {{payload: {from: *, to: *, layer: *}, type: string}}
 */
export const applyDateFilter = (layer, from, to, type) => {
    return {
        type   : 'DATE_FILTER_APPLIED',
        payload: {
            layer: layer,
            from : from,
            to   : to,
            type : type
        }
    };
};

/**
 * apply cql filter for mitra restorasi gambut layer
 *
 * @param pelaksana
 * @param pendana
 * @returns {{payload: {pelaksana: *, pendana: *}, type: string}}
 */
export const applyMitraRestorasiFilter = (pelaksana, pendana) => {
    return {
        type   : 'MITRA_RESTORASI_FILTER_APPLIED',
        payload: {
            pelaksana: pelaksana,
            pendana  : pendana
        }
    }
}

/**
 * apply cql filter for hotspot layer
 *
 * @returns {{payload: {pelaksana: *, pendana: *}, type: string}}
 * @param confidenceLevel
 * @param source
 */
export const applyHotspotFilter = data => {
    return {
        type   : 'HOTSPOT_FILTER_APPLIED',
        payload: data
    }
}